export default __webpack_public_path__ + "static/media/DNo.28-3.d0379850.jpg";